export const getRandomColor = () => {
    const randomValue = () => Math.floor(Math.random() * 256);
    const r = randomValue();
    const g = randomValue();
    const b = randomValue();
    return `rgb(${r}, ${g}, ${b})`;
}